import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../Redux/store";

type Account = {
    name: string;
    branch: string;
    mobile: string;
    phone: string;
    email: string;
    writer: string;
    branchData: {
        PHONE: string;
        ["Z_MGR_NAME"]: string;
        ["Z_MGR_MOBILE"]: string;
        ["Z_MGR_DID"]: string;
        ["Z_MGR_EMAIL"]: string;
        ["Z_LOCATION"]: string;
        ["Z_SHIPTO_STREET1"]: string;
        ["Z_SHIPTO_STREET2"]: string;
        ["Z_SHIPTO_CITY"]: string;
        ["Z_SHIPTO_STATE"]: string;
        ["Z_SHIPTO_ZIP"]: string;
        ["Z_CONTACT_FAX"]: string;
    }
};

const baseUrl = 'https://customer.hirsch.com/account/v2/employee'

export const getAccount = createAsyncThunk<Account[], void, {state: RootState, rejectValue: string}>(
    'account/getAccount',
    async(_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;

            const response = await fetch(baseUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                }
            })
            const json = await response.json()
            
            return json.employee;
        } catch (err: any) {
            console.log('Account Error:', err)
            return rejectWithValue(err)
        }
    }
);

type AccountState = {
    loading: boolean;
    error: boolean | null | undefined | string;
    accountArr: Account[];
}

const initialState: AccountState = {
    accountArr: [],
    loading: false,
    error: null,
}

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getAccount.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getAccount.fulfilled, (state, action) => {
            state.loading = false;
            state.accountArr = action.payload;
            state.error = null;
        })
        .addCase(getAccount.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })
    }
});

export const accountReducer = accountSlice.reducer;

export const userAccount = (state: RootState) => {
    return state.account.accountArr;
};